import { render, staticRenderFns } from "./SimpleColorMatrix.vue?vue&type=template&id=344a9e30&scoped=true&lang=pug"
import script from "./SimpleColorMatrix.vue?vue&type=script&lang=ts"
export * from "./SimpleColorMatrix.vue?vue&type=script&lang=ts"
import style0 from "./SimpleColorMatrix.vue?vue&type=style&index=0&id=344a9e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344a9e30",
  null
  
)

export default component.exports